
import {Customer, AbstractCustomerProvider} from '../../providers/customer/types';
import { AbstractCustomerService } from './types';

export interface AbstractCustomerSetter {
    setCustomer: (customer: Customer) => void;
    updateCustomer: (accessToken: string) => void;
}

export class CustomerService  implements AbstractCustomerService {
  private provider: AbstractCustomerProvider;
  private setter: AbstractCustomerSetter;

  constructor(provider: AbstractCustomerProvider, setter: AbstractCustomerSetter) {
    this.provider = provider;
    this.setter = setter;
  }

  
  async getCustomerByEmail(email: string): Promise<Customer> {
    const customer = await this.provider.getCustomerByEmail(email);
    this.setter.setCustomer(customer);

    return customer;
  }

  async createCustomer(customer: Customer): Promise<Customer> {
    const createdCustomer = await this.provider.createCustomer(customer);
      console.log('createdCustomer', createdCustomer);

    this.setter.setCustomer(createdCustomer);
    return createdCustomer;
  }
}